import setEmailOnGuestCart from './setEmailOnGuestCart';

export default setEmailOnGuestCart;
